import { render, staticRenderFns } from "./scanPackMove.vue?vue&type=template&id=0aa71e9d&"
import script from "./scanPackMove.vue?vue&type=script&lang=js&"
export * from "./scanPackMove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports